import { MenuItem, Select, TextField, Typography } from '@mui/material'
import { MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getKazooGuests } from '../../features/userSlice'
import { getStaffInfo } from '../../features/vendorSlice'
import { fetchEventTags } from '../../features/guestListSlice'
import EventTagsField from '../tags/EventTagsField'
import { useParams } from 'react-router-dom'

export const TaskForm = ({ task, setTask }) => {
	const dispatch = useDispatch()
	const { kazooId } = useParams()

	const guests = useSelector((state) => state.user.guests).filter(
		(guest) => !guest.status
	)
	const partyMembers = useSelector((state) => state.kazooEvent.kazooMembers)
	const staff = useSelector((state) => state.vendor.staff).filter(
		(staff) => !staff.status
	)
	const eventTagCatalog = useSelector((state) => state.guestList.eventTags)

	const inputStyles = {
		marginBottom: '1em',
	}

	useEffect(() => {
		dispatch(getKazooGuests(kazooId))
		dispatch(getStaffInfo())
		if (kazooId) dispatch(fetchEventTags(kazooId))
	}, [dispatch, kazooId])

	return (
		<>
			<Typography>Task Name</Typography>
			<TextField
				data-cy="taskName"
				placeholder="Task name"
				sx={inputStyles}
				hiddenLabel
				variant="outlined"
				value={task.name}
				onChange={(e) => setTask({ ...task, name: e.target.value })}
			/>

			<Typography>Assigned users</Typography>
			<MultiSelectComponent
				value={task.assignedUsers}
				dataSource={[...staff]}
				fields={{ text: 'name', value: 'staffId' }}
				placeholder="Select users"
				mode="Default"
				data-cy="assign-users-dropdown"
				changeOnBlur={false}
				onChange={(e) => {
					setTask({ ...task, assignedUsers: e.value })
				}}
			/>

			<Typography>Able to view</Typography>
			<MultiSelectComponent
				value={task.ableToView}
				id="ableToView"
				name="ableToView"
				className="e-field"
				dataSource={[
					...(!partyMembers.bride?.status && partyMembers.bride?._id
						? [
								{
									id: partyMembers.bride?._id,
									text:
										partyMembers.bride?.preferredName ||
										`${partyMembers.bride?.firstName} ${partyMembers.bride?.lastName}`,
								},
							]
						: []),
					...(!partyMembers.groom?.status && partyMembers.groom?._id
						? [
								{
									id: partyMembers.groom?._id,
									text:
										partyMembers.groom?.preferredName ||
										`${partyMembers.groom?.firstName} ${partyMembers.groom?.lastName}`,
								},
							]
						: []),
					...guests.map((guest) => ({
						id: guest._id,
						text:
							guest.preferredName ||
							`${guest.firstName} ${guest.lastName}`,
					})),
				]}
				changeOnBlur={false}
				fields={{ text: 'text', value: 'id' }}
				placeholder="Select users"
				mode="Default"
				data-cy="able-to-view-dropdown"
				onChange={(e) => setTask({ ...task, ableToView: e.value })}
			/>

			<Typography>Task Type</Typography>
			<Select
				data-cy="taskType"
				sx={inputStyles}
				value={task.type}
				onChange={(e) => setTask({ ...task, type: e.target.value })}
			>
				<MenuItem value={'Transport'}>Transport</MenuItem>
				<MenuItem value={'Activity'}>Activity</MenuItem>
				<MenuItem value={'Food'}>Food</MenuItem>
				<MenuItem value={'Station'}>Station</MenuItem>
			</Select>

			<Typography>Priority</Typography>
			<Select
				sx={inputStyles}
				defaultValue={1}
				value={task.priority}
				onChange={(e) => setTask({ ...task, priority: e.target.value })}
			>
				<MenuItem value={1}>Low</MenuItem>
				<MenuItem value={2}>Medium</MenuItem>
				<MenuItem value={3}>High</MenuItem>
			</Select>

			<Typography>Status</Typography>
			<Select
				sx={inputStyles}
				defaultValue={0}
				value={task.status}
				onChange={(e) => setTask({ ...task, status: e.target.value })}
			>
				<MenuItem value={0}>Not started</MenuItem>
				<MenuItem value={1}>In progress</MenuItem>
				<MenuItem value={2}>Pending</MenuItem>
				<MenuItem value={3}>Awaiting approval</MenuItem>
				<MenuItem value={4}>Completed</MenuItem>
			</Select>

			<Typography>Comments</Typography>
			<TextField
				sx={inputStyles}
				placeholder="Add comments"
				hiddenLabel
				multiline
				rows={3}
				value={task.comments}
				onChange={(e) => setTask({ ...task, comments: e.target.value })}
			/>

			<EventTagsField
				value={task.eventTags || []}
				onChange={(tags) => setTask({ ...task, eventTags: tags })}
				catalog={eventTagCatalog}
				kazooId={kazooId}
			/>
		</>
	)
}
